import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const UPDATE_WATCH_LIST_ENTRY = createAsyncActionType(
  "UPDATE_WATCH_LIST_ENTRY"
);

export const GET_WATCH_LIST_ENTRIES = createAsyncActionType(
  "GET_WATCH_LIST_ENTRIES"
);

export const GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES = createAsyncActionType(
  "GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES"
);

export const GET_WATCH_LIST_ENTRY = createAsyncActionType(
  "GET_WATCH_LIST_ENTRY"
);

export const GET_WATCH_LIST_ENTRY_BY_ID = createAsyncActionType(
  "GET_WATCH_LIST_ENTRY_BY_ID"
);

export const GET_WATCH_LIST_ENTRIES_COUNT = createAsyncActionType(
  "GET_WATCH_LIST_ENTRIES_COUNT"
);

export const GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_COUNT =
  createAsyncActionType("GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_COUNT");

export const CREATE_WATCH_LIST_ENTRY = createAsyncActionType(
  "CREATE_WATCH_LIST_ENTRY"
);

export const DELETE_WATCH_LIST_ENTRY = createAsyncActionType(
  "DELETE_WATCH_LIST_ENTRY"
);

export const CLEAR_WATCH_LIST_ENTRIES = "CLEAR_WATCH_LIST_ENTRIES";

export const CLEAR_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES =
  "CLEAR_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES";

export const SET_WATCH_LIST_ENTRIES_SEARCH_FILTERS =
  "SET_WATCH_LIST_ENTRIES_SEARCH_FILTERS";

export const CHANGE_ITEMS_PER_PAGE_WATCHLIST_ENTRIES =
  "CHANGE_ITEMS_PER_PAGE_WATCHLIST_ENTRIES";

export const CHANGE_ITEMS_PER_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES =
  "CHANGE_ITEMS_PER_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES";

export const CHANGE_CURRENT_PAGE_WATCHLIST_ENTRIES =
  "CHANGE_CURRENT_PAGE_WATCHLIST_ENTRIES";

export const CHANGE_CURRENT_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES =
  "CHANGE_CURRENT_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES";

export const SET_NO_ENTRIES_MESSAGE_WATCHLIST_ENTRIES =
  "SET_NO_ENTRIES_MESSAGE_WATCHLIST_ENTRIES";

export const SET_NO_ENTRIES_MESSAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES =
  "SET_NO_ENTRIES_MESSAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES";

export const SET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_FILTERS =
  "SET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_FILTERS";



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/types/watchListEntryTypes.js